import { regiao, cidadesVizinhas, listar } from "./cidades.js";

const distancia = (nome) => regiao.find((cidade) => cidade.nome === nome).km;

export const proximas = regiao.filter((cidade) => cidade.km > 0 && cidade.km <= 21).sort((a, b) => a.km - b.km);

export const faixasDeDistancia = [
  { titulo: "Até 25 km de Orleans", minimo: 0, maximo: 25 },
  { titulo: "De 26 a 50 km", minimo: 26, maximo: 50 },
  { titulo: "Mais de 50 km", minimo: 51, maximo: Infinity },
];

export const locais = {
  orleans: {
    slug: "/software-em-orleans-sc",
    titulo: "Sistemas e software em Orleans, SC | Hawx Soluções",
    descricao: "Empresa de software em Orleans, SC. Sistemas sob medida, automação de processos e diagnóstico presencial para empresas de Orleans e cidades vizinhas.",
    rotulo: "Software em Orleans, SC",
    cidades: ["Orleans"],
    h1: "Sistemas e software sob medida em Orleans, SC",
    destaque: "Orleans, SC",
    subtitulo: "Criamos sistemas sob medida e automações para empresas de Orleans. O diagnóstico é presencial, na sua empresa.",
    mensagem: "Olá! Minha empresa fica em Orleans e quero conversar sobre um sistema.",
    apresentacao: {
      rotulo: "Software em Orleans",
      titulo: "Uma empresa de software perto da sua",
      texto: "A Hawx é uma empresa de desenvolvimento de software com sede em Orleans, no sul de Santa Catarina. Para empresas da cidade, o diagnóstico é feito pessoalmente, no lugar onde o trabalho acontece.",
      itens: [
        { titulo: "Visita na sua empresa", texto: "Acompanhamos o processo com as pessoas e as ferramentas de verdade antes de propor qualquer sistema." },
        { titulo: "Sistema sob medida", texto: "Web, celular ou computador, com os campos, as etapas e os relatórios que a sua equipe usa." },
        { titulo: "Automação do que já existe", texto: "Conectamos os sistemas, as planilhas e os e-mails que a empresa já usa, sem trocar tudo." },
        { titulo: "Suporte depois da entrega", texto: "A mesma equipe implanta o sistema, acompanha o uso e ajusta quando o processo muda." },
      ],
    },
    vizinhas: {
      rotulo: "Região",
      titulo: "Também atendemos as cidades vizinhas",
      texto: `Além de Orleans, o diagnóstico é presencial nas cidades vizinhas, como ${listar(proximas.map((cidade) => `${cidade.nome} (${cidade.km} km)`))}, e em outras cidades do sul de Santa Catarina.`,
    },
    perguntas: [
      { p: "A Hawx é uma empresa de Orleans?", r: "Sim. A Hawx Soluções tem sede em Orleans, no sul de Santa Catarina, e atende empresas da cidade e da região desde 2024." },
      { p: "Vocês fazem visita presencial em Orleans?", r: "Sim. O diagnóstico é presencial: visitamos a sua empresa, acompanhamos o processo acontecendo e entregamos o plano do que resolver primeiro." },
      { p: "A Hawx vende sistema pronto?", r: "Não. Cada sistema é feito sob medida para o processo da sua empresa, com os campos, as etapas e os relatórios que a equipe usa. Se a empresa já tem um sistema, conectamos o que já existe em vez de trocar tudo." },
      { p: "Quanto custa um sistema sob medida em Orleans?", r: "Depende do que o sistema precisa fazer. A conversa inicial é sem compromisso e a proposta vem com orçamento gratuito, escopo e prazo definidos antes de qualquer trabalho começar." },
      { p: "Vocês atendem empresas de fora de Orleans?", r: `Sim. O diagnóstico também é presencial nas cidades vizinhas, como ${listar(cidadesVizinhas.slice(0, 5))}. Desenvolvimento, implantação e suporte acontecem com acompanhamento à distância, para empresas de toda Santa Catarina.` },
    ],
  },
  regiao: {
    slug: "/onde-atendemos",
    titulo: "Empresa de software no sul de SC | Hawx Soluções",
    descricao: "Cidades atendidas pela Hawx a partir de Orleans, SC: Tubarão, Criciúma, Urussanga, Lauro Müller, Braço do Norte e região, com diagnóstico presencial.",
    rotulo: "Onde atendemos",
    cidades: regiao.map((cidade) => cidade.nome),
    h1: "Empresa de software no sul de Santa Catarina",
    destaque: "sul de Santa Catarina",
    subtitulo: "Sede em Orleans, diagnóstico presencial nas cidades da região e acompanhamento à distância para empresas de toda Santa Catarina.",
    mensagem: "Olá! Vi as cidades atendidas no site da Hawx e quero conversar sobre um sistema para a minha empresa.",
    mapa: {
      rotulo: "Área de atendimento",
      titulo: "Cidades atendidas a partir de Orleans",
      texto: "A sede da Hawx fica em Orleans. O diagnóstico é presencial nas cidades do mapa, e o desenvolvimento, a implantação e o suporte acontecem com acompanhamento à distância.",
      legenda: "Distâncias aproximadas, em linha reta, entre o centro de Orleans e o centro de cada cidade.",
    },
    metodo: {
      rotulo: "Método Hawx",
      titulo: "Como funciona na sua cidade",
      numerada: true,
      itens: [
        { titulo: "Conversa no WhatsApp", texto: "Você conta o que precisa e em que cidade fica a sua empresa. Sem compromisso e sem formulário." },
        { titulo: "Visita presencial", texto: "Vamos até a sua empresa, acompanhamos o processo acontecendo e apontamos o que resolver primeiro." },
        { titulo: "Proposta", texto: "Orçamento gratuito, com escopo e prazo definidos antes de qualquer trabalho começar." },
        { titulo: "Acompanhamento à distância", texto: "Você acompanha o desenvolvimento, recebe o sistema implantado e tem suporte depois da entrega." },
      ],
    },
    perguntas: [
      { p: "Vocês atendem a minha cidade?", r: "O diagnóstico é presencial nas cidades do mapa, e empresas de toda Santa Catarina são atendidas com acompanhamento à distância. Se a sua cidade não aparece, fale no WhatsApp com a localização da empresa e combinamos o atendimento." },
      { p: "Preciso ir até Orleans?", r: "Não. O diagnóstico acontece na sua empresa, e o desenvolvimento, a implantação e o suporte têm acompanhamento à distância." },
      { p: "Vocês atendem empresas de Tubarão e Criciúma?", r: `Sim. Tubarão fica a cerca de ${distancia("Tubarão")} km de Orleans e Criciúma a cerca de ${distancia("Criciúma")} km, em linha reta. O diagnóstico é presencial nas duas cidades.` },
      { p: "Vocês atendem fora do sul de Santa Catarina?", r: "Sim. Desenvolvimento, implantação e suporte acontecem com acompanhamento à distância, para empresas de toda Santa Catarina." },
    ],
  },
};
